import { render, staticRenderFns } from "./AddLocationType.vue?vue&type=template&id=0a94a748&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLocationType.vue"
export default component.exports